/**
 * Geometria do arco do gauge, extraída do vetor do Figma (node 233:2687):
 * viewBox 223.365x99, centro (111.68, 111.68), raio 106, espessura 11.4.
 * O arco não é um semicírculo cheio — vai de 171° a 9°, passando pelo topo.
 */
export const GAUGE_VIEWBOX = { width: 223.365, height: 99 } as const;
export const GAUGE_CENTER = { x: 111.68, y: 111.68 } as const;
export const GAUGE_RADIUS = 106;
export const GAUGE_THICKNESS = 11.4;
export const GAUGE_START_ANGLE = 171;
export const GAUGE_END_ANGLE = 9;

function pointOnArc(angleDegrees: number): { x: number; y: number } {
  const radians = (angleDegrees * Math.PI) / 180;
  return {
    x: GAUGE_CENTER.x + GAUGE_RADIUS * Math.cos(radians),
    y: GAUGE_CENTER.y - GAUGE_RADIUS * Math.sin(radians),
  };
}

/** Caminho SVG do arco entre dois ângulos, sempre no sentido horário (start > end). */
export function arcPath(startAngle: number, endAngle: number): string {
  const start = pointOnArc(startAngle);
  const end = pointOnArc(endAngle);
  const largeArc = startAngle - endAngle > 180 ? 1 : 0;
  return `M ${start.x} ${start.y} A ${GAUGE_RADIUS} ${GAUGE_RADIUS} 0 ${largeArc} 1 ${end.x} ${end.y}`;
}

/** Ângulo final do arco preenchido para um percentual 0-100. */
export function angleForPercentage(percentage: number): number {
  const safe = Number.isFinite(percentage) ? Math.min(100, Math.max(0, percentage)) : 0;
  return GAUGE_START_ANGLE - (GAUGE_START_ANGLE - GAUGE_END_ANGLE) * (safe / 100);
}
